import Grid from '@mui/material/GridLegacy';
import { capitalizeFirstLetter, isDefined } from '../../../config/helpers';



const Surcharges = ({ data }) => {
    const surchargeLeftStyle = {
        fontWeight: "normal",
        textAlign: "left",
    };

    const surchargeRightStyle = {
        fontWeight: "bold",
        textAlign: "right",
    };


    const subtotalStyle = { padding: "15px" };

    const totalCosts = data.order_product_total;

    const currency = (amount) => {
        if (amount < 0) {
            amount = amount.substring(1);
            amount = "- £" + parseFloat(amount).toFixed(2);
        } else {
            amount = "£" + parseFloat(amount).toFixed(2);
        }
        return amount;
    };

    return (
        <div style={subtotalStyle}>
            {isDefined(
                data.charges.damage_fees && totalCosts.length == 0
            ) ? (
                <Grid container>
                    <Grid item xs={6}>
                        <p style={surchargeLeftStyle}>
                            Damage Waiver Fee
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <p style={surchargeRightStyle}>
                            {currency(
                                data.charges.damage_fees
                            )}
                        </p>
                    </Grid>
                </Grid>
            )
                : totalCosts.damage_waiver && totalCosts.damage_waiver != null
                    ?
                    <Grid container>
                        <Grid item xs={6}>
                            <p style={surchargeLeftStyle}>
                                Damage Waiver Fee
                            </p>
                        </Grid>
                        <Grid item xs={6}>
                            <p style={surchargeRightStyle}>
                                {currency(
                                    totalCosts.damage_waiver
                                )}
                            </p>
                        </Grid>
                    </Grid>
                    : null

            }
            {!isDefined(
                data.charges.delivery_cost
            ) ? null : (
                <Grid container>
                    <Grid item xs={6}>
                        <p style={surchargeLeftStyle}>Delivery Cost</p>
                    </Grid>
                    <Grid item xs={6}>
                        <p style={surchargeRightStyle}>
                            {
                                currency(
                                    data.charges
                                        .delivery_cost
                                )
                            }
                        </p>
                    </Grid>
                </Grid>
            )}
            {!isDefined(
                data.charges.collection_cost
            ) ? null : (
                <Grid container>
                    <Grid item xs={6}>
                        <p style={surchargeLeftStyle}>
                            Collection Cost
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <p style={surchargeRightStyle}>
                            {
                                currency(
                                    data.charges
                                        .collection_cost
                                )
                            }
                        </p>
                    </Grid>
                </Grid>
            )}
            {isDefined(
                data.charges.weekend_delivery
            ) &&
                data.charges.weekend_delivery &&
                parseFloat(
                    data.charges.weekend_delivery_cost
                ) != 0 && totalCosts.length != 0 ? (
                <Grid container>
                    <Grid item xs={6}>
                        <p style={surchargeLeftStyle}>
                            Weekend Delivery Cost
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <p style={surchargeRightStyle}>
                            {currency(
                                data.charges
                                    .weekend_delivery_cost
                            )}
                        </p>
                    </Grid>
                </Grid>
            ) : null
            }
            {/* {
                totalCosts.length != 0 && totalCosts.transport_costs.delivery.del_sunday == 'yes' && totalCosts.transport_costs.delivery.del_date_offset == 0 ?
                <Grid container>
                    <Grid item xs={6}>
                        <p style={surchargeLeftStyle}>
                            Weekend Delivery Cost
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <p style={surchargeRightStyle}>
                            {currency(
                                totalCosts.transport_costs.delivery
                                    .weekend_delivery_cost
                            )}
                        </p>
                    </Grid>
                </Grid>
                : null
            } */}


            {isDefined(
                data.charges.weekend_delivery
            ) &&
                data.charges.weekend_delivery &&
                parseFloat(
                    data.charges.weekend_collection_cost
                ) != 0 && totalCosts.length != 0 ? (
                <Grid container>
                    <Grid item xs={6}>
                        <p style={surchargeLeftStyle}>
                            Weekend Collection Cost
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <p style={surchargeRightStyle}>
                            {currency(
                                data.charges
                                    .weekend_collection_cost
                            )}here
                        </p>
                    </Grid>
                </Grid>
            ) : null
            }
            {/* {
                totalCosts.length != 0 && totalCosts.transport_costs.collection.col_sunday == 'yes' && totalCosts.transport_costs.collection.col_date_offset == 0 ?
                <Grid container>
                    <Grid item xs={6}>
                        <p style={surchargeLeftStyle}>
                            Weekend Collection Cost
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <p style={surchargeRightStyle}>
                            {currency(
                                totalCosts.transport_costs.collection
                                    .weekend_collection_cost
                            )}
                        </p>
                    </Grid>
                </Grid>
                : null
            } */}

            {isDefined(data.charges.del_option) &&
                data.charges.del_option && totalCosts.length == 0 && (
                    <Grid container>
                        <Grid item xs={6}>
                            {!isDefined(
                                data.charges.del_option_id
                            ) ? null : (
                                <p style={surchargeLeftStyle}>
                                    {
                                        data.charges
                                            .del_option_id.name
                                    }{" "}
                                    {
                                        data.charges
                                            .del_option_id.start_time
                                    }
                                    -
                                    {
                                        data.charges
                                            .del_option_id.end_time
                                    }
                                </p>
                            )}
                        </Grid>
                        <Grid item xs={6}>
                            <p style={surchargeRightStyle}>
                                {currency(
                                    data.charges
                                        .del_option_cost
                                )}
                            </p>
                        </Grid>
                    </Grid>
                )

            }
            {isDefined(data.charges.col_option) &&
                data.charges.col_option && totalCosts.length == 0 && (
                    <Grid container>
                        <Grid item xs={6}>
                            {!isDefined(
                                data.charges.col_option_id
                            ) ? null : (
                                <p style={surchargeLeftStyle}>
                                    {
                                        data.charges
                                            .col_option_id.name
                                    }{" "}
                                    {
                                        data.charges
                                            .col_option_id.start_time
                                    }
                                    -
                                    {
                                        data.charges
                                            .col_option_id.end_time
                                    }
                                </p>
                            )}
                        </Grid>
                        <Grid item xs={6}>
                            <p style={surchargeRightStyle}>
                                {currency(
                                    data.charges
                                        .col_option_cost
                                )}
                            </p>
                        </Grid>
                    </Grid>
                )

            }

            {(isDefined(data.charges.install) ||
                data.charges.install ||
                parseFloat(data.charges.install_cost) ==
                0) && totalCosts.length == 0 && (
                    <Grid container>
                        <Grid item xs={6}>
                            <p style={surchargeLeftStyle}>Install Cost</p>
                        </Grid>
                        <Grid item xs={6}>
                            <p style={surchargeRightStyle}>
                                {currency(
                                    data.charges
                                        .install_cost
                                )}
                            </p>
                        </Grid>
                    </Grid>
                )

            }
            {(isDefined(data.charges.derig) ||
                data.charges.derig ||
                parseFloat(data.charges.derig_cost) ==
                0) && totalCosts.length == 0 && (
                    <Grid container>
                        <Grid item xs={6}>
                            <p style={surchargeLeftStyle}>Derig Cost</p>
                        </Grid>
                        <Grid item xs={6}>
                            <p style={surchargeRightStyle}>
                                {currency(
                                    data.charges.derig_cost
                                )}
                            </p>
                        </Grid>
                    </Grid>
                )

            }
            {!isDefined(
                data.charges
                    .balance_to_meet_min_hire_charge
            ) ? null : (
                <Grid container>
                    <Grid item xs={6}>
                        <p style={surchargeLeftStyle}>
                            Balance to meet Minimum Hire Charge (£
                            {parseFloat(
                                data.charges
                                    .min_hire_charge
                            ).toFixed(2)}
                            )
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <p style={surchargeRightStyle}>

                            {
                                currency(
                                    parseFloat(
                                        data.charges
                                            .balance_to_meet_min_hire_charge
                                    ).toFixed(2))
                            }
                        </p>
                    </Grid>
                </Grid>
            )}
            {
                isDefined(data.charges.HNS) && totalCosts.length == 0
                    ? data.charges.HNS.map((hns, index) => {
                        return (
                            <Row key={index}>
                                <Grid item xs={6}>
                                    <p style={surchargeLeftStyle}>
                                        {capitalizeFirstLetter(hns.name)}
                                    </p>
                                </Grid>
                                <Grid item xs={6}>
                                    <p style={surchargeRightStyle}>
                                        {currency(hns.price)}
                                    </p>
                                </Grid>
                            </Row>
                        );
                    })
                    : totalCosts && totalCosts.balance_to_meet_min_hire_charge != null
                        ?
                        <Grid container>
                            <Grid item xs={6}>
                                <p style={surchargeLeftStyle}>
                                    Balance to meet minimum hire charge
                                </p>
                            </Grid>
                            <Grid item xs={6}>
                                <p style={surchargeRightStyle}>
                                    {currency(totalCosts.balance_to_meet_min_hire_charge)}
                                </p>
                            </Grid>
                        </Grid>
                        : null
            }
        </div>
    )
}

export default Surcharges